import React, { useEffect, useState } from 'react'
import { ISelectedItems } from '../__toolbarContent/displays__toolbarContent'
import styles from './iptvSwitch.jcss'
import EditText from '../../../blocks.simple/editText/editText'
import displaysHelpers from 'core/helpers/_digitalSignages'
import translate from '../../../core/translate'
import { api } from '../../../core/api/ConnectionManager'
import Icon from '../../../blocks.simple/icon/icon'
import { Radio } from '../../../atoms/Radio'
import Button from '../../../blocks.simple/button/button'
import { colors } from '../../../theme'
import { cn } from 'ethcss'
import Dotdotdot from 'react-dotdotdot'
import item from '../../../blocks.simple/item/item.jcss'
import DotTooltip from '../../../blocks.simple/dotTooltip/dotTooltip'

type ChannelItem = {
    id: number
    title: string
    devicesCount: number
    isIntersected: boolean
}

export const IpTvSwitchChannel = ({
    selectedItems,
    onClose,
}: {
    selectedItems: ISelectedItems[]
    onClose: () => void
}) => {
    const [channelList, setChannelList] = useState<ChannelItem[]>([])
    const [search, setSearch] = useState<string>('')
    const [onlyIntersected, setOnlyIntersected] = useState<boolean>(false)

    const getChannels = () => {
        const digitalSignageId: number[] = []
        const groupId: number[] = []

        selectedItems.forEach((item) => {
            if (item.type === 'digitalSignage') {
                digitalSignageId.push(item.id)
            }
            if (item.type === 'group') {
                groupId.push(item.id)
            }
        })

        api.send<object, ChannelItem[]>('iptvGetChannels', { digitalSignageId, groupId }).then((res) => {
            setChannelList(res)
        })
    }

    const switchChannel = (channelId: number) => {
        const digitalSignageId: number[] = []
        const groupId: number[] = []

        selectedItems.forEach((item) => {
            if (item.type === 'digitalSignage') {
                digitalSignageId.push(item.id)
            }
            if (item.type === 'group') {
                groupId.push(item.id)
            }
        })

        api.send('iptvSwitchChannel', { channelId, digitalSignageId, groupId }).then(() => {
            if (selectedItems.length > 1 || (selectedItems.length === 1 && selectedItems[0].type === 'group')) {
                onClose()
            }
        })
    }

    const isPlayingCheck = (channelId: number) => {
        if (selectedItems.length > 1) {
            return false
        }

        const playingChannels = selectedItems.length && selectedItems[0].currentlyPlaying

        if (playingChannels && playingChannels.length) {
            return playingChannels[0].entityObject.id === channelId
        }

        return false
    }

    const playingChannelName =
        selectedItems.length === 1 && selectedItems[0].currentlyPlaying
            ? displaysHelpers.getChannelName(selectedItems[0].currentlyPlaying)
            : null

    useEffect(() => {
        getChannels()
    }, [])

    return (
        <div className={styles.modalWrapper}>
            <div className={styles.modalInner}>
                <div className={styles.title}>{translate('channelSwitch')}</div>
                {selectedItems.length > 1 || (selectedItems.length === 1 && selectedItems[0].type === 'group') ? (
                    <div>
                        <div className={styles.desc}>{translate('channelSwitchAllWarning')}</div>
                        <div className={styles.viewMode}>
                            <div className={styles.viewModeTitle}>{translate('channelSwitchViewMode')}</div>
                            <div className={styles.viewModeRadioWrapper}>
                                <Radio
                                    className={styles.radio}
                                    label={translate('fullChannelList')}
                                    selected={!onlyIntersected}
                                    onClick={() => setOnlyIntersected(false)}
                                />
                                <Radio
                                    className={styles.radio}
                                    label={translate('intersectingChannels')}
                                    selected={onlyIntersected}
                                    onClick={() => setOnlyIntersected(true)}
                                />
                            </div>
                        </div>
                    </div>
                ) : null}
                <div className={styles.search}>
                    <EditText
                        value={search}
                        onChange={(value: string) => setSearch(value)}
                        placeholder={translate('searchByIpTvChannelName')}
                    />
                    <div
                        className={styles.inputActionBtn}
                        onClick={() => {
                            setSearch('')
                        }}
                    >
                        <Icon type={search.length ? 'close' : 'search'} size={14} />
                    </div>
                </div>
                <div
                    className={
                        selectedItems.length > 1 || (selectedItems.length === 1 && selectedItems[0].type === 'group')
                            ? styles.channelListMulti
                            : styles.channelList
                    }
                >
                    <div className={styles.channelListCaption}>
                        {playingChannelName
                            ? translate('iptvNowPlaying') + ': ' + playingChannelName
                            : translate('channelsNames')}
                    </div>
                    <div className={styles.listWrapper}>
                        {channelList
                            .filter((channel) => channel.title.toLowerCase().includes(search.toLowerCase()))
                            .map((channel) => {
                                if (!channel.isIntersected && onlyIntersected) {
                                    return null
                                }

                                const isPlaying = isPlayingCheck(channel.id)

                                return (
                                    <div
                                        onClick={() => {
                                            switchChannel(channel.id)
                                        }}
                                        className={cn(styles.channelItem, isPlaying ? styles.channelItemPlaying : '')}
                                        key={channel.id}
                                    >
                                        <div style={{ width: 'calc(100% - 20px)' }}>
                                            <DotTooltip tooltip={{ html: channel.title }}>
                                                <div className={item.ellipsis}>{channel.title}</div>
                                            </DotTooltip>
                                        </div>
                                        {isPlaying && (
                                            <div className={styles.play}>
                                                <Icon type={'play'} size={10} color={colors.blueAccent} />
                                            </div>
                                        )}
                                    </div>
                                )
                            })}
                        {!channelList.filter((channel) => channel.title.toLowerCase().includes(search.toLowerCase()))
                            .length && <div className={styles.noChannels}>{translate('noChannels')}</div>}
                    </div>
                </div>
                <div className={styles.closeButtonWrapper}>
                    <Button mod={'withBorder'} onClick={onClose}>
                        {translate('close')}
                    </Button>
                </div>
            </div>
        </div>
    )
}
